<template>
  <div class="card-container">

    <Row class="header-container">
      <Col span="24" class="box-header">
        <h2>Ходовой товар</h2>
      </Col>
      <Col span="24" class="box-header-filter">
        <Menu
          mode="horizontal"
          :active-name="defaultFilter"
          @on-select="selectFilter"
        >
          <MenuItem name="year" class="menu-item">
            Год
          </MenuItem>
          <MenuItem name="month" class="menu-item">
            Месяц
          </MenuItem>
          <MenuItem name="week" class="menu-item">
            Неделя
          </MenuItem>
          <MenuItem name="day" class="menu-item">
            День
          </MenuItem>
        </Menu>
      </Col>
    </Row>

    <div v-if="displayTable">
      <Row class="box-table-header">
        <Col :xs="6" :sm="7">Наименование</Col>
        <Col :xs="5" :sm="4">Цена</Col>
        <Col :xs="3" :sm="4">Кол-во</Col>
        <Col :xs="6" :sm="5">Выручка</Col>
        <!--        <Col span="4">Рентабельность</Col>-->
        <Col :xs="4" :sm="4">Маржа</Col>
      </Row>

      <Row class="box-table-row" v-for="item in data">
        <Col :xs="6" :sm="7" style=" text-align: left; font-weight: 600"> {{formatShortText(item.name)}}</Col>
        <Col :xs="5" :sm="4">{{formatNumber(item.average_price)}} {{ $store.state.currency }}</Col>
        <Col :xs="3" :sm="4">{{item.total_count}}</Col>
        <Col :xs="6" :sm="5">{{formatNumber(item.total_sum)}} {{ $store.state.currency }}</Col>
        <!--        <Col span="4">{{formatNumber(item.profitability)}} %</Col>-->
        <Col :xs="4" :sm="4">{{formatNumber(item.marginality)}} %</Col>
      </Row>


    </div>
    <div v-else class="box-no-data">
      Нет данных для отображения
    </div>

    <!--    <h2>Средний чек (продажа)</h2>-->
    <!--    <h1 class="average_order">{{ formatNumber(data) }} {{ $store.state.currency }}</h1>-->
    <Spin size="large" v-if="loading"></Spin>
  </div>
</template>

<script>
    import {formatShortText} from "../../base/base_func";
    import {base_url} from "../../http";

    import {formatNumber} from "../../base/base_func";



    export default {
        name: "topProductsTable",
        data() {
            return {
                loading: true,
                data: [],
                defaultFilter: "month"
            };
        },
        computed: {
            displayTable(){
                return this.data.length!==0
            }
        },
        // Загружаем данные для таблицы
        methods: {
            selectFilter: function (period) {
                // console.log(name);
                this.fetchData(period);
            },
            fetchData: function (period) {
                this.loading = true;
                this.lastDraw++;
                let url = `${base_url}/charts/top_products/`;
                this.$http
                    .get(url, {
                        params: {period: period}
                    })
                    .then(result => {
                        this.data = result.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            formatNumber(val) {
                return formatNumber(val);
            },

            formatShortText(text) {
                if (text.length > 20 ){
                    return text.slice(0, 20) + '...';
                }
                else
                    return text;

            },
        },
        mounted: function () {
            this.fetchData(this.defaultFilter);
        }
    };
</script>

<style scoped>
  .card-container {
    padding: 10px;
    position: relative;
  }
  .header-container {
    padding: 10px 20px;
  }
  .box-header {
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    padding-bottom: 10px;
  }
  .box-header-filter {
    text-align: right;
    /*font-weight: bold;*/
    /*font-size: 10px !important;*/
    /*color: rgb(141, 141, 141) !important;*/
  }
  .ivu-menu-horizontal {
    height: auto;
    line-height: 1.2;
    margin-bottom: 20px;
  }
  .box-no-data {
    font-size: 20px;
    color: #80808094;
    margin: 80px 0;
  }
  .ivu-menu {
    z-index: 1;
  }
  .menu-item {
    font-size: 16px;
    line-height: 30px !important;
    padding: 0 5px !important;
    float: right;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    /*color: #2d8cf0;*/
    /*border-bottom: None;*/
    /*font-weight: bold;*/
    color: rgba(37, 215, 126, 1);
    border-bottom: unset;
  }
  .ivu-menu-horizontal.ivu-menu-light::after {
    background: white;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    border-bottom: unset;
    /*color: #515a6e;*/
  }
  .ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-horizontal .ivu-menu-submenu {
    color: #8080809e;
    /*float: left;*/
    /*padding: 0 10px;*/
    /*position: relative;*/
    /*cursor: pointer;*/
    /*z-index: 3;*/
    /*transition: all 0.2s ease-in-out;*/
  }
  .box-table-header {
    font-size: 12px;
    text-align: center;
    margin: 30px 0 20px 0;
    color:grey;
  }
  .box-table-row {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);
    padding: 13px;
    border-radius: 20px;
    position: relative;
    font-size: 15px;
    margin: 20px 0;
    /*text-align: left;*/
  }

  @media screen and (max-width: 1900px) {
    .box-table-row {
      font-size: 14px;
    }
    .menu-item {
      font-size: 15px;
    }
  }

  @media screen and (max-width: 1500px) {
    .box-table-row {
      font-size: 13px;
    }
    .menu-item {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 991px) {
    h2 {
      font-size: 18px;
    }
  }

  @media screen and (max-width: 767px) {
    .box-table-row, .box-table-header {
      font-size: 12px;
    }

  }

  @media screen and (max-width: 575px) {
    .box-table-row, .box-table-header {
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/home/topProductsTable.vue